module["exports"] = [
  "резервное копирование",
  "обход",
  "архивирование",
  "взлом",
  "шифрование",
  "переопределение",
  "сжатие",
  "скачивание",
  "копирование",
  "навигация",
  "индексирование",
  "соединение",
  "генерация",
  "определение количества",
  "вычисление",
  "синтез",
  "передача",
  "программирование",
  "разбор"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/hacker/ingverb.js
// module id = 3530
// module chunks = 1609